module.exports = __webpack_public_path__ + "img/phone2.2374257d.png";